import { render, staticRenderFns } from "./TwitchProfile.vue?vue&type=template&id=66441fdb&"
import script from "./TwitchProfile.vue?vue&type=script&lang=js&"
export * from "./TwitchProfile.vue?vue&type=script&lang=js&"
import style0 from "./TwitchProfile.vue?vue&type=style&index=0&id=66441fdb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports